import Pusher, { Channel } from 'pusher-js'

import Ajax from 'pusher-js/types/src/core/http/ajax'
import { PUSHER_TIMEOUT_MILI } from 'constants.js'
import _ from 'lodash'

//This object handles WebSocket interaction and also stores open channels, since they cannot be stored in the store as
//they are not serializable. When needed, the store holds a reference to the channel name and retrieves it from here.
class WsChannelProvider {
    channels: { [key: string]: Channel | undefined } = {}
    pusher: Pusher | null = null

    start() {
        Pusher.Runtime.createXHR = function() {
            let xhr = new XMLHttpRequest()
            xhr.withCredentials = true
            return xhr as Ajax
        }
        //Pusher setup
        this.pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY!, {
            authEndpoint: `${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/chat`,
            cluster: 'us3',
            //forceTLS: true
            //encrypted: true
            auth: {
                params: {},
                headers: {
                    'X-Pusher-Token': process.env.REACT_APP_X_PUSHER_TOKEN,
                },
            },
        })
    }

    setWsChannel(channelName, wsChannel) {
        this.channels[channelName] = wsChannel
    }

    getWsChannel(channelName) {
        return this.channels[channelName]
    }

    openWsChannel(channelName): Promise<Channel> {
        return new Promise((resolve, reject) => {
            try {
                if (!this.pusher) {
                    this.start()
                }
                const wsChannel = this.pusher!.subscribe(channelName)
                this.setWsChannel(channelName, wsChannel)

                if (wsChannel.pusher.connection.state === 'disconnected') {
                    wsChannel.pusher.connect()
                }

                const timeoutId = setTimeout(() => {
                    reject(new Error('Pusher connection timeout'))
                }, PUSHER_TIMEOUT_MILI)

                wsChannel.pusher.connection.bind('connected', () => {
                    clearTimeout(timeoutId)
                    //TODO we should test this to measure what the average latency is until the callback is called
                    wsChannel.name = channelName
                    resolve(wsChannel)
                })
            } catch (err) {
                reject(err)
            }
        })
    }

    closeWsChannel(channelName) {
        if (!this.pusher) return
        // As above, this might be called on a channel that hasnt't yet been registered.
        const channel = this.channels[channelName]

        if (channel) {
            channel.pusher.unbind()
            channel.pusher.disconnect()
        }
        this.pusher.unsubscribe(channelName)
        delete this.channels[channelName]
        if (_.isEmpty(this.channels)) {
            this.pusher.disconnect()
        }
    }
}

export default WsChannelProvider
